export const combineFacetReportStrings = (combined, facetReportStrings) => (
    combined.concat(...facetReportStrings)
);

export const buildFacetReportString = allFacets => (
    facetType => (
        allFacets[facetType].map(({ name, tagDisplayLabel, searchFacetOptionId }) => (
            `${facetType}=${tagDisplayLabel || name || searchFacetOptionId }`
        ))
    )
);

export const facetEngagementAdapter = facetData => {

  if(!facetData){
    return '';
  }

  const { appliedFacets, facetSelected } = facetData;

  return Object.keys(appliedFacets || facetSelected)
               .filter(facetType => facetType !== 'storeId')
               .map(buildFacetReportString(appliedFacets || facetSelected))
               .reduce(combineFacetReportStrings, [])
               .join(' | ')
};
